import React from 'react';
import Radio from '@mui/material/Radio';

export const VpRadio = ({ ...rest }) => {
  return <Radio {...rest} />;
};



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpRadio.jsx